import { useEffect } from "react";
import WorkGrid from "@/components/site/WorkGrid";

export default function WorkPage() {
    useEffect(() => {
        document.title = "Work — MIDI Pictures";
    }, []);
    return (
        <main data-testid="work-page" className="bg-black pt-32 md:pt-40">
            <div className="px-6 md:px-12 mb-12 md:mb-20">
                <p className="text-[11px] tracking-[0.32em] uppercase text-white/45 mb-6">Archive</p>
                <h1 className="font-display tracking-tightest leading-[0.78] text-6xl md:text-8xl lg:text-[160px]">
                    Work<span className="text-[color:var(--midi-accent-strong)]">.</span>
                </h1>
            </div>
            <WorkGrid showHeader={false} />
        </main>
    );
}
